<template>
    <div class="px-4 py-4 sm:px-10 sm:mt-4">
        <a :href="route('auth_login_display_localized')" class="inline-flex items-end justify-center px-5 py-3 border border-transparent text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700">{{translate('body:registerButton')}}</a>
    </div>
</template>
<script>

import {useForm, usePage, Link} from "@inertiajs/inertia-vue3";
import { ExclamationCircleIcon } from '@heroicons/vue/24/solid'
import translate from "../../../lang";
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid';


export default {
    components: {
        Link,
        ExclamationCircleIcon,
        ExclamationTriangleIcon
    },
    props: {
    },

    setup() {
        return {
            translate: translate('auth.resetSuccess'),
        }
    }
}

</script>
